import { SpendableDetails } from "./SpendableDetails";

export type SpendablesForModules = {
  [ruleModuleKey: string]: SpendableDetails[];
};

export enum SpendingOnType {
  XP = "XP",
  RULES = "RULES",
  STATS = "STATS",
}
